<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',

}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';

.c-header {
  background-color: #262626;
}

.c-header-nav-link {
  color: #fff !important;
}

.c-subheader {
  display: none;
}

.c-sidebar-brand>svg {
  display: none !important;
}

.c-sidebar {
  color: #fff;
  background: #262626;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* Global classes */
.disabled>input,
.disabled>.dropdown {
  pointer-events: none;
  opacity: 0.7;
}

// border css for vue-editor "Validate both translations"
.quillWrapper.is-invalid .ql-toolbar,
.quillWrapper.is-invalid #quill-container {
  border-color: red;
}
</style>
